import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { useNotifications } from '../../contexts/notificationContext';
import ProjectStatusModel from '../../models/ProjectStatusModel';
import DataService from "../../services/data.service";
import ProjectStatuses_popup_CreateProjectStatus from './Popups/ProjectStatuses_popup_CreateProjectStatus';

const ProjectStatuses: React.FC = () => {
    const [data, setData] = useState<ProjectStatusModel[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState(false)

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/projectStatuses')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: ProjectStatusModel) {
        DataService.delete('api/v1/projectStatuses/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <div className='main-content'>
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card title='Project statuses'
                            content={
                                <DataTable
                                    name='dtProjectStatuses'
                                    tableData={data}
                                    navigateTitle='Project status'
                                    navigateUrl='/plm/workflowsetup/projectstatus/'
                                    colInfos={[
                                        { key: true, dataProp: 'id', visible: false },
                                        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                                        {
                                            headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                                            rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
                                        }
                                    ]}

                                />
                            }
                        />
                    </Col>
                </Row>
            </Container>
            {showPopup && <ProjectStatuses_popup_CreateProjectStatus show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </div>
    );
}
export default ProjectStatuses;